<template>
    <oss-dialog
        persistent
        v-model="dialog"
        :max-width="!$vuetify.display.mobile ? '900px' : undefined"
        :fullscreen="$vuetify.display.mobile"
        :hide-overlay="$vuetify.display.mobile"
        :title="title"
        :actions="actions"
        :previous-display="!disabledPrevious()"
        @previous="previous()"
        prefixDataCy="DocumentWizardDialog-valid"
        min-width="60vw"
    >
        <DocumentWizard
            ref="documentWizard"
            :companyId="companyId"
            :documentId="documentId"
            :documentType="documentType"
            :amount="amount"
            :multiple="multiple"
            :showFirstPrevious="showFirstPrevious"
            :inGlobalStep="inGlobalStep"
            :inExtensions="inExtensions"
            :openCameraOnly="openCameraOnly"
            :dialog="true"
            :actions="actions"
            :ownerId="ownerId"
            @files-uploaded="onFilesUploaded"
            @startMiscellaneousOperation="onStartMiscellaneousOperation"
            @startMiscellaneous="onStartMiscellaneous"
            @startLoanOcr="onStartLoanOcr"
            @back="onBack"
            @created="onCreated"
            @new-document="onNewDocument"
            @insideDocumentType="onInsideDocumentTypeChanged"
            @globalStep="onGlobalStepChanged"
            @wizardStep="onWizardStepChanged"
            @invoiceType="onInvoiceTypeChanged"
            @close="closeDialog()"
            class="w-100"
            :style="{ minHeight: $vuetify.display.mobile ? '60vh' : '' }"
        />
    </oss-dialog>
</template>

<script lang="ts">
import { DialogAction } from "../../services/dialogAction";
import { Component, Ref, Vue, Watch, toNative } from "vue-facing-decorator";
import { Prop, Model } from "vue-facing-decorator";
import DocumentWizard, { DocumentWizard as DocumentWizardType } from "./DocumentWizard.vue";
@Component({
    components: {
        DocumentWizard,
    },
    emits: [
        "update:active",
        "back",
        "files-uploaded",
        "created",
        "new-document",
        "startMiscellaneousOperation",
        "startMiscellaneous",
        "startLoanOcr",
    ],
})
export class DocumentWizardDialog extends Vue {
    @Model() value!: boolean;
    @Prop({ default: "" }) readonly companyId: string;
    @Prop({ default: "" }) readonly documentId: string;
    @Prop({ default: "" }) readonly documentType: string;
    @Prop({ default: 0 }) readonly amount: number;
    @Prop({ default: true }) readonly multiple: boolean;
    @Prop({ default: true }) readonly showFirstPrevious: boolean;
    @Prop({ default: "" }) readonly inGlobalStep: string;
    @Prop({ default: null }) readonly inExtensions: any;
    @Prop({ default: false }) readonly openCameraOnly: boolean;
    @Prop({ default: null }) readonly ownerId: string;

    insideDocumentType = "";
    globalStep = "";
    wizardStep = 1;
    invoiceType = "";

    actions: any = {
        action: new DialogAction(),
    };

    level = "Parent";

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get dialog() {
        return this.value;
    }

    set dialog(event) {
        // debugger
        this.value = event;
    }

    nextDisabled = false;

    get workingDocumentType() {
        return this.insideDocumentType || this.documentType;
    }

    set workingDocumentType(value) {
        this.insideDocumentType = value;
    }

    disabledPrevious() {
        if (this.wizardStep === 1) return true;
        if (
            this.wizardStep === 2 &&
            this.globalStep === "start" &&
            !this.selectedCompany.profile.createSalesInvoice
        )
            return true;

        if (this.wizardStep === 12 && this.globalStep === "loan") return true;
        return false;
    }

    get title() {
        // debugger;
        if (this.workingDocumentType === "BANK_STATEMENT") {
            return "Relevé bancaire";
        }
        if (this.workingDocumentType === "PAY_SLIP") {
            return "Bulletins de paie";
        }
        if (this.workingDocumentType === "PURCHASE_INVOICE") {
            return "Factures d'achat";
        }
        if (this.workingDocumentType === "SALES_INVOICE") {
            return "Factures de vente";
        }
        if (this.workingDocumentType === "EXPENSE_REPORT_DOCUMENT") {
            return "Justificatifs de note de frais";
        }
        if (this.workingDocumentType === "EXPENSE_REPORT_DOCUMENT") {
            return "Justificatifs divers";
        }
        if (this.globalStep === "expenseReport") {
            return "Note de frais";
        }
        if (this.globalStep === "zTillReceipt" || this.globalStep === "zTillReceiptUpload") {
            return "Z de caisse";
        }
        if (this.globalStep === "invoice") {
            if (this.invoiceType === "invoice") {
                return "Création de facture";
            }
            if (this.invoiceType === "quotation") {
                return "Création de devis";
            }
            if (this.invoiceType === "billDelivery") {
                return "Création d'un bon de livraison";
            }
            return "Facture de vente";
        }
        if (this.globalStep === "subscription") {
            return "Ajouter un abonnement";
        }

        switch (this.wizardStep) {
            case 1:
                return "Justificatifs";
            case 2:
                return "Justificatifs de dépense";
            case 3:
            case 4:
                return "Justificatifs de recette";
            case 6:
                return "Échéancier";
            case 7:
                return "Divers";
            case 8:
            case 9:
            case 10:
            case 11:
                return "Banque";
            case 12:
                return "Emprunts";
        }
        return "Justificatifs";
    }

    close() {
        this.$emit("update:active", false);
    }

    @Ref("documentWizard") readonly documentWizard!: DocumentWizardType;
    next() {
        this.documentWizard.next();
    }

    nextOfChild() {
        if (this.actions) {
            this.actions.function();
        }
    }

    onBack() {
        this.$emit("back");
    }

    previous() {
        this.$refs.documentWizard.previousStep();
    }

    onFilesUploaded() {
        this.$emit("files-uploaded");
    }

    onCreated() {
        this.$emit("created");
        this.dialog = false;
    }

    onNewDocument(data) {
        // debugger;
        this.$emit("new-document", data);
    }

    onInsideDocumentTypeChanged(data) {
        this.insideDocumentType = data;
    }

    onGlobalStepChanged(data) {
        this.globalStep = data;
    }

    onWizardStepChanged(data) {
        // debugger
        this.wizardStep = data;
    }

    onInvoiceTypeChanged(data) {
        this.invoiceType = data;
    }

    closeDialog() {
        this.dialog = false;
        this.$emit("files-uploaded");
    }

    onStartMiscellaneousOperation() {
        this.$emit("startMiscellaneousOperation");
    }

    onStartMiscellaneous() {
        this.$emit("startMiscellaneous");
    }

    /**
     * Event for modify documentType for loan ocr
     */
    onStartLoanOcr() {
        this.$emit("startLoanOcr");
    }
}

export default toNative(DocumentWizardDialog);
</script>
